/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BulbMobileLauncherTranslationProvider } from '../translation-provider';
import { UtilitiesService } from '../utilities.service';
import { ButtonStyle } from '../../../aero/aero-button/aero-button.component';

@Component({
  selector: 'bulb-mobile-launch-toast',
  templateUrl: './mobile-launch-toast.component.html',
  styleUrls: ['./mobile-launch-toast.component.scss'],
  providers: [
    BulbMobileLauncherTranslationProvider,
  ],
  standalone: false,
})
export class MobileLaunchToastComponent implements OnInit {

  public buttonStylePrimary = ButtonStyle.PRIMARY_2;

  public buttonStyleSecondary = ButtonStyle.GREY;

  private messageServiceKey = 'mobileLaunchPopup';

  constructor(private messageService: MessageService, private utilityService: UtilitiesService) {

  }

  ngOnInit(): void {
    setTimeout(() => {
      const isIOS = this.utilityService.checkIfOnIOS();

      // Check if clever is the referrer.
      const fromClever = this.utilityService.isFromClever();

      // Check if app was dismissed.
      const stillDismissed = this.utilityService.isStillDismissed();

      if (stillDismissed && !fromClever) {
        // We want to always show the alert if the user is logging in from clever.

        // Since the user recently dismissed the toast, and they are not from clever, go ahead and return.

        return;
      }

      if (isIOS) {
        this.showToast();
      }
      // Show the popup after 1.2 seconds.
    }, 1200);

  }

  openPressed() {
    this.utilityService.openIOSApp();
  }

  noPressed() {
    // Pressed Cancel, go ahead and hide the alert for the next 8 hours.
    this.utilityService.setDismissed();
    this.messageService.clear(this.messageServiceKey);
  }

  showToast() {
    this.messageService.add({
      key: this.messageServiceKey,
      severity: 'success',
      sticky: true,
    });
  }
}
